//AzeemKhan : 17-05-2023 : BT-107430 -  Breeze – Watchlist Side Tray - Don't Miss - Start
import { memo, useEffect, useMemo, useState, useCallback } from "react";
import { useLocation } from "react-router";
import { Container, Row, Col } from "react-bootstrap";
import { BzButton, BzCard, BzChip, BzHeading, BzInputText, BzToolTip } from "../../components";
import { useDispatch, useSelector } from "react-redux";
import { LOCATIONS, SCRIP_INSTRUMENTS, TL_INDEX, TRADING_NOT_ALLOWED_MSG, WATCHLIST_GRID_INDEX } from "../../utils/global_variables";
import DontMissChip from "./DontMissChip";
import { useWFHMessages, useUnload } from "../../hooks";
import { sendBestFiveRequest, sendTouchlineRequest } from "../../apis/web_socket";
import ZeroStates from "../ZeroStates";
import { handleModal } from "../../redux/actions/modals";
import { uniqBy } from "lodash";
import { searchDontMissBySymbol, setDontMissSearchByDropdown } from "../../redux/actions/dontMiss";
import { getExchangeWiseScripInfo, getScripOrderInfo } from "../../redux/actions/orders";
import { setScripOverviewData } from "../../redux/actions/marketOverview";
// Prachi T : 21-11-2023 : BT-107423 - Breeze - Dashboard recommemndations
import { ORDER_ENTRY_GRID_REF, deepClone, getApiExchangeNameFromMktSegId, isUserIsAGuest } from "../../utils/global_functions";
import { toastConfig } from "../../redux/actions/toast";
import { FiltersModalPortfolio } from "../Portfolio";
import CustomVirtualizer from "../../components/CustomVirtulaizer";
// Prachi T : 21-11-2023 : BT-107423 - Breeze - Dashboard recommemndations


const DontMissAndWatchlistName = ({ data }) => {

    const arrDontMissEventAndWatchlistName = useMemo(() => {
        const arrWatchlistName = data[WATCHLIST_GRID_INDEX.DONT_MISS_WATCHLISTS]?.map((item) => ({ event: item, bg_color: 'default-chip', icon: 'icon-eye' }));
        return [...data[WATCHLIST_GRID_INDEX.DONT_MISS], ...arrWatchlistName];
    }, [data]);


    return (
        <DontMissChip value={arrDontMissEventAndWatchlistName} nShowChip={2} />
    );

};



const DontMiss = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const objLoginSession = useSelector(state => state.auth.objLoginSession);// Prachi T : 21-11-2023 : BT-107423 - Breeze - Dashboard recommemndations

    const handlePlaceOrder = useCallback(async (data, nIsBuyOrSell = 0, activeExchangeName = 'NSE') => {
        if (!isUserIsAGuest('buy_sell')) {//Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- Start
            // Prachi T : 21-11-2023 : BT-107423 - Breeze - Dashboard recommemndations
            const strExchangeName = getApiExchangeNameFromMktSegId(data[WATCHLIST_GRID_INDEX.SEGMENT_ID]);
            if (objLoginSession?.data?.exchanges?.includes(strExchangeName?.toUpperCase())) {
                ORDER_ENTRY_GRID_REF.current.setIsScripPrice(false); //Ameersha N : 10-01-2024 --BREEZE - BT-117134 Breeze Portfolio - Holdings - Don't Miss --issue limit is not getting set 
                // Prachi T : 21-11-2023 : BT-107423 - Breeze - Dashboard recommemndations
                dispatch(getScripOrderInfo({ isBuySell: nIsBuyOrSell, activeExchangeName, scripData: data }));
                await dispatch(getExchangeWiseScripInfo(data));
                dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': true }]));
                // Prachi T : 21-11-2023 : BT-107423 - Breeze - Dashboard recommemndations
            }
            else {
                dispatch(toastConfig({ autoDismiss: true, show: true, message: TRADING_NOT_ALLOWED_MSG }));
            }
        } else {

        }//Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- End

    }, [dispatch, objLoginSession?.data?.exchanges]);
    // Prachi T : 21-11-2023 : BT-107423 - Breeze - Dashboard recommemndations

    const BuySellButtons = useCallback(({ data }) => {

        const nIndex = data[WATCHLIST_GRID_INDEX.DONT_MISS]?.findIndex((item) => item?.buySell?.toUpperCase() === 'BUY' || item?.buySell?.toUpperCase() === 'SELL');
        return (
            data[WATCHLIST_GRID_INDEX.DONT_MISS][nIndex]?.buySell?.toUpperCase() === 'BUY' ?
                <BzButton className='btn btn-sm btn-positive ms-2' onClick={handlePlaceOrder.bind(this, data, 0)}>BUY</BzButton> :
                data[WATCHLIST_GRID_INDEX.DONT_MISS][nIndex]?.buySell?.toUpperCase() === 'SELL' ?
                    <BzButton className='btn btn-sm btn-negative ms-2' onClick={handlePlaceOrder.bind(this, data, 1)}>SELL</BzButton> :
                    <>
                        <BzButton className='btn btn-sm btn-positive' onClick={handlePlaceOrder.bind(this, data, 0)}>BUY</BzButton>
                        <BzButton className='btn btn-sm btn-negative ms-2' onClick={handlePlaceOrder.bind(this, data, 1)}>SELL</BzButton>
                    </>
        );
    }, []);

    const dontMissData = useSelector(state => state?.dontMiss?.dontMissData);
    const strSearchDontMissBySymbol = useSelector(state => state?.dontMiss?.strSearchDontMissBySymbol);
    const arrSearchDontMissByDropdown = useSelector(state => state?.dontMiss?.arrSearchDontMissByDropdown);
    const holdingsScrips = useSelector(state => state?.holdings?.holdingsScrips);
    const [nActiveCardIndex, nASetActiveCardIndex] = useState(null);
    const [dontMissScrips, setDontMissScrips] = useState([]);

    const dontScripsByLocation = useMemo(() => {
        if (location.pathname === LOCATIONS.WATCHLIST) {
            if (dontMissData?.length > 0) {
                return [...dontMissData];
            } else {
                return [];
            }
        } else if (location.pathname === LOCATIONS.PORTFOLIO || location.pathname === LOCATIONS.DASHBOARD) {
            if (holdingsScrips?.length && dontMissData?.length) {
                let scrips = [];
                holdingsScrips?.forEach((eachScrip) => {
                    const dontMiss = dontMissData?.find(data => data[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === `${eachScrip?.nMarketSegmentId}_${eachScrip?.nToken}`);
                    if (dontMiss) {
                        scrips?.push(dontMiss);
                    } else { }
                });
                return scrips;

            }
            else {
                return [];
            }
        } else {
            if (dontMissData?.length > 0) {
                return [...dontMissData];
            } else {
                return [];
            }
        }
    }, [dontMissData, holdingsScrips, location.pathname]);






    const arrDontMissScripData = useMemo(() => (
        arrSearchDontMissByDropdown?.length
            ?
            dontScripsByLocation?.filter((scrip) => {
                const arrDontMissInfo = scrip[WATCHLIST_GRID_INDEX.DONT_MISS];
                return arrDontMissInfo?.some((event) => arrSearchDontMissByDropdown.includes(event?.event));
            })?.filter((symbol) => (
                symbol[WATCHLIST_GRID_INDEX.SYMBOL]?.toUpperCase()?.includes(strSearchDontMissBySymbol?.toUpperCase()))
            )
            : (
                strSearchDontMissBySymbol ?
                    dontScripsByLocation?.filter((symbol) => symbol[WATCHLIST_GRID_INDEX.SYMBOL]?.toUpperCase()?.includes(strSearchDontMissBySymbol?.toUpperCase()))
                    : dontScripsByLocation
            )


    ), [arrSearchDontMissByDropdown, dontScripsByLocation, strSearchDontMissBySymbol]);


    const updateScripWithTouchlineData = (arrTouchLineData) => {
        setDontMissScrips(arrDontMissScrips => {
            if (arrDontMissScrips?.length > 0) {
                const nIndex = arrDontMissScrips?.findIndex(scrip => scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === arrTouchLineData[TL_INDEX.SEGMENT_ID]?.toString() + '_' + arrTouchLineData[TL_INDEX.TOKEN]?.toString());
                if (nIndex >= 0) {
                    const arrScripToBeUpdated = arrDontMissScrips[nIndex];
                    if (arrScripToBeUpdated && arrScripToBeUpdated?.length > 0) {
                        //By HiralK : 06-09-2023 : For Price optimization - Start
                        arrScripToBeUpdated[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE] = arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE];
                        arrScripToBeUpdated[WATCHLIST_GRID_INDEX.LTP_PERCENT] = arrTouchLineData[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE];
                        //Maaz A : 04-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start
                        // const nAbsPrevColse = (arrTouchLineData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE]);//.toFixed(arrScripToBeUpdated[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                        //By HiralK : 06-09-2023 : For Price optimization - End
                        // if (nAbsPrevColse > 0) {
                        //     arrTouchLineData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] = '+' + nAbsPrevColse.toString();
                        // } else if (nAbsPrevColse < 0) {
                        //     arrTouchLineData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] = nAbsPrevColse.toString();
                        // }
                        // else {
                        //     arrTouchLineData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] = nAbsPrevColse.toString();
                        // }
                        //Maaz A : 04-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - End
                        arrScripToBeUpdated[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP] = arrTouchLineData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE];
                        arrScripToBeUpdated[WATCHLIST_GRID_INDEX.BID_PRICE] = arrTouchLineData[TL_INDEX.BUY_PRICE];
                        arrScripToBeUpdated[WATCHLIST_GRID_INDEX.BID_PRICE_INDICATOR] = arrTouchLineData[TL_INDEX.BUY_PRICE_INDICATOR];
                        arrScripToBeUpdated[WATCHLIST_GRID_INDEX.NET_CHANGE_INDICATOR] = arrTouchLineData[TL_INDEX.NET_CHANGE_INDICATOR];
                        arrScripToBeUpdated[WATCHLIST_GRID_INDEX.BID_QUANTITY] = arrTouchLineData[TL_INDEX.BUY_QTY];
                        arrScripToBeUpdated[WATCHLIST_GRID_INDEX.ASK_PRICE] = arrTouchLineData[TL_INDEX.SELL_PRICE];
                        arrScripToBeUpdated[WATCHLIST_GRID_INDEX.ASK_PRICE_INDICATOR] = arrTouchLineData[TL_INDEX.SELL_PRICE_INDICATOR];
                        arrScripToBeUpdated[WATCHLIST_GRID_INDEX.ASK_QTY] = arrTouchLineData[TL_INDEX.SELL_QTY];
                        arrScripToBeUpdated[WATCHLIST_GRID_INDEX.HIGH] = arrTouchLineData[TL_INDEX.HIGH_PRICE];
                        arrScripToBeUpdated[WATCHLIST_GRID_INDEX.LOW] = arrTouchLineData[TL_INDEX.LOW_PRICE];
                        arrScripToBeUpdated[WATCHLIST_GRID_INDEX.OPEN] = arrTouchLineData[TL_INDEX.OPEN_PRICE];
                        arrScripToBeUpdated[WATCHLIST_GRID_INDEX.CLOSE] = arrTouchLineData[TL_INDEX.CLOSE_PRICE];
                        arrScripToBeUpdated[WATCHLIST_GRID_INDEX.VOLUME] = arrTouchLineData[TL_INDEX.VOLUME];
                        arrScripToBeUpdated[WATCHLIST_GRID_INDEX.ATP] = arrTouchLineData[TL_INDEX.AVG_TRADED_PRICE];

                        arrDontMissScrips[nIndex] = arrScripToBeUpdated;
                    } else { }
                } else { }
            } else { }
            return [...arrDontMissScrips];
        });
    };


    useEffect(() => {
        if (dontScripsByLocation?.length > 0) { // Ameersha this need to bee changes when subscription for visibel scrips in watchlist side tray is applied
            nASetActiveCardIndex(dontScripsByLocation[0][WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]);
            setDontMissScrips([...dontScripsByLocation]);
        } else {

        }

        return () => {
            if (dontScripsByLocation?.length > 0) {
                const arrSubscriptionScrips = dontScripsByLocation?.map(scrip => ({ exchangeId: scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID], token: scrip[WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: false }));
                sendTouchlineRequest(arrSubscriptionScrips);
            }
        };

    }, [dontMissData, location?.pathname, dontScripsByLocation]);
    useWFHMessages('touchline', (e) => {
        updateScripWithTouchlineData([...e.detail]);
    });
    const handleOverview = (each, e) => {
        e.preventDefault();
        if (e?.target?.tagName?.toLowerCase() === 'button') return;
        nASetActiveCardIndex(each[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]);
        sendBestFiveRequest({ exchangeId: each[WATCHLIST_GRID_INDEX.SEGMENT_ID], token: each[WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: true });
        dispatch(setScripOverviewData(each));
        dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': true }]));
    };
    const [dontMissEvent, setDontMissEvent] = useState([]);
    const [arrDontMissEvents, setArrDontMissEvents] = useState([]);
    const [bToggleSearchBar, setBToggleSearchBar] = useState(true);


    useEffect(() => {
        if (dontScripsByLocation?.length > 0) {
            setArrDontMissEvents(uniqBy((dontScripsByLocation?.map(each => each[WATCHLIST_GRID_INDEX.DONT_MISS]).flat()), "event"));
            nASetActiveCardIndex(dontScripsByLocation[0][WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]);
        }
    }, [dontScripsByLocation]);




    useUnload(() => {
        // handleDontMissScripsUnSubscription();
        dispatch(searchDontMissBySymbol(''));
        dispatch(setDontMissSearchByDropdown([]));
    });




    //Ameersha N -09-01-2024 - BREEZE -- BT-117134-Breeze Portfolio - Holdings - Don't Miss-Start
    const handleFilterEventDelete = useCallback((event) => {
        if (dontMissEvent.includes(event)) {
            setDontMissEvent(dontMissEvent?.filter((item) => item !== event));
            dispatch(setDontMissSearchByDropdown(dontMissEvent?.filter((item) => item !== event)));
        } else {
            let copy = deepClone(arrSearchDontMissByDropdown);
            let arrFilteredEvents = copy?.filter((item) => item !== event);
            dispatch(setDontMissSearchByDropdown([...arrFilteredEvents]));
        }
    }, [dontMissEvent, arrSearchDontMissByDropdown, dispatch]);

    const handleSearchScripBySymbol = useCallback((e) => {
        dispatch(searchDontMissBySymbol(e.target.value));
    }, []);

    //Ameersha N -09-01-2024 - BREEZE -- BT-117134-Breeze Portfolio - Holdings - Don't Miss-Start
    const handleFilterOfDontMiss = useCallback(() => {
        let copy = deepClone(arrSearchDontMissByDropdown);
        dispatch(setDontMissSearchByDropdown([...copy]));
        dispatch(handleModal([{ "PORTFOLIO_DONT_MISS_FILTERS": true }]));
    }, [dispatch, arrSearchDontMissByDropdown]);
    //Ameersha N -09-01-2024 - BREEZE -- BT-117134-Breeze Portfolio - Holdings - Don't Miss-End





    const customListRenderer = useCallback(({ index, data, style }) => {
        let each = data[index];
        return (
            <div key={index} style={style}>

                <BzCard id={each[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]} key={each[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]} className={`sidetray-card bdr-btm cursor-pointer ${nActiveCardIndex === each[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] ? 'active' : ''}`} onClick={handleOverview.bind(this, each)}>
                    <Row className='g-0'>
                        <Col md={4}>
                            <div className='d-flex mb-1'>
                                <BzHeading className='font-medium font-size3 color-text text-uppercase me-2'>{each[WATCHLIST_GRID_INDEX.SYMBOL]}</BzHeading>
                                <div className='icon-16 icon-dontmiss icon-yellow me-2'></div>
                                {
                                    holdingsScrips?.some(element => element?.ISIN === each[WATCHLIST_GRID_INDEX.ISIN_CODE] && each[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES) &&
                                    <div className='icon-16 icon-portfolio icon-dark'></div>
                                }
                            </div>
                            <div className='mb-1 d-flex buysell-button-wrap'>
                                <div className='chips-wrap mb-1'>
                                    <BzChip className='exchange-chip me-1 float-start'>{each[WATCHLIST_GRID_INDEX.EXCHANGE]}</BzChip>
                                </div>
                                <div className='font-regular font-size1 color-subtext float-start'>{each[WATCHLIST_GRID_INDEX.EXPIRYDATE]}</div>
                            </div>
                        </Col>
                        <Col md={8} className='mb-3'>
                            <div className='d-flex justify-content-end'>
                                <div>
                                    <div className='d-flex justify-content-end align-self-center'>
                                        <div className='font-medium font-size3 color-text'>{each[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE]}</div>
                                    </div>
                                    <div className='d-flex justify-content-end align-self-center'>
                                        <div className={`font-regular font-size1 color-text me-1 ${each[WATCHLIST_GRID_INDEX.LTP_PERCENT]?.split("")[0] === '+' ? "color-positive" : (each[WATCHLIST_GRID_INDEX.LTP_PERCENT]?.split("")[0] === '-' ? "color-negative" : '')} `}>{each[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP]}</div>
                                        <div className={`font-regular font-size1 color-text ${each[WATCHLIST_GRID_INDEX.LTP_PERCENT]?.split("")[0] === '+' ? "color-positive" : (each[WATCHLIST_GRID_INDEX.LTP_PERCENT]?.split("")[0] === '-' ? "color-negative" : '')} `}>({each[WATCHLIST_GRID_INDEX.LTP_PERCENT]}%)</div>
                                    </div>
                                </div>
                                <div className='d-flex ms-3'>
                                    <div>
                                        <BuySellButtons data={each} />
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row className='g-0 mb-2'>
                        <Col className='d-flex justify-content-start align-items-center'>
                            <div className='chips-wrap'>
                                <DontMissAndWatchlistName data={each} />
                            </div>
                        </Col>
                    </Row>
                    <Row className='g-0'>
                        <Col className='d-flex justify-content-end align-self-center'>
                            <div className='font-regular font-size1 color-subtext'>{each?.time}</div>
                        </Col>
                    </Row>
                </BzCard>

            </div>
        );
    }, [handleOverview, holdingsScrips, nActiveCardIndex]);

    const renderItem = useCallback(({ index, data, style }) => {
        let each = data[index];
        return (
            <div key={index} style={style}>
                {

                    each?.length > 0 &&
                    <BzCard id={each[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]} key={each[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]} className={`sidetray-card bdr-card-btm cursor-pointer ${nActiveCardIndex == each[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] ? 'active' : ''}`} onClick={handleOverview.bind(this, each)}>
                        <Container fluid className='p-0'>
                            <Row className='g-0'>
                                <Col md={7}>
                                    <div className='font-medium font-size4 color-text text-uppercase'>{each[WATCHLIST_GRID_INDEX.SYMBOL]}</div>
                                    <div className='my-1 text-truncate'>
                                        <span className='font-medium font-size4 color-text'>{each[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE]}</span>
                                        <span className={`font-regular font-size3 color-text ms-1 ${each[WATCHLIST_GRID_INDEX.LTP_PERCENT]?.split("")[0] === '+' ? "color-positive" : (each[WATCHLIST_GRID_INDEX.LTP_PERCENT]?.split("")[0] === '-' ? "color-negative" : '')} `}>{each[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP]}</span>
                                        <span className={`font-regular font-size3 color-text ms-1 ${each[WATCHLIST_GRID_INDEX.LTP_PERCENT]?.split("")[0] === '+' ? "color-positive" : (each[WATCHLIST_GRID_INDEX.LTP_PERCENT]?.split("")[0] === '-' ? "color-negative" : '')} `}>({each[WATCHLIST_GRID_INDEX.LTP_PERCENT]}%)</span>
                                    </div>
                                </Col>
                                <Col md={5}>
                                    <div className='text-end d-inline-flex'>
                                        <BuySellButtons data={each} />
                                    </div>
                                </Col>
                            </Row>
                        </Container>

                        <Row className='g-0 mb-2'>
                            <Col className='d-flex justify-content-start align-self-center'>
                                <div className='d-flex align-items-center'>
                                    <div className='chips-wrap align-items-center'>
                                        <DontMissAndWatchlistName data={each} />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row className='g-0'>
                            <Col>
                                <div className='font-regular font-size1 color-subtext'>{each?.time}</div>
                            </Col>
                        </Row>
                    </BzCard>
                }
            </div>
        );
    }, [handleOverview, nActiveCardIndex]);



    return (
        <>
            <FiltersModalPortfolio setDontMissEvent={setDontMissScrips} arrDontMissEvents={arrDontMissEvents} />
            {
                location.pathname === LOCATIONS.WATCHLIST ?
                    <div className='sticky-dontmiss-height'>
                        {arrDontMissScripData?.length > 0 ?
                            <Container fluid className='p-0 h-100' >
                                <div className='sidetray-card-wrap h-100' >
                                    <CustomVirtualizer data={arrDontMissScripData} itemHeight={116} renderItem={customListRenderer} />
                                </div>
                            </Container> :
                            <div className='zero-state-alerts zero-state-alerts-xxl'>
                                <ZeroStates subText="No Data Found" icon='icon-64 icon-nodata mb-3 mrgauto' />
                            </div>
                        }

                    </div>
                    //AzeemKhan : 17-05-2023 : BT-107430 -  Breeze – Watchlist Side Tray - Don't Miss - End
                    : (
                        location.pathname === LOCATIONS.DASHBOARD ?
                            <Container fluid className='p-0'>
                                <Row className='g-0 mb-2 align-items-center'>
                                    <Col className='d-flex justify-content-start align-items-center p-t-5'>
                                        <div className='icon-16 icon-dontmiss icon-yellow me-2'></div>
                                        <div className='font-medium font-size4 color-text me-2'>Don't Miss ({arrDontMissScripData.length ? arrDontMissScripData.length : '0'})</div>
                                        <BzToolTip placement='right' TooltipMsg='Get scrip related Events, Recommendations and Holding info upfront'>
                                            <div className='icon-16 icon-info icon-dark'></div>
                                        </BzToolTip>
                                    </Col>
                                </Row>
                                <Row className='g-0'>
                                    <Col md={12}>
                                        <div className='dashboard-dontmiss' >
                                            <div className='sidetray-card-wrap' style={{ flex: '1 1 auto', height: '100%' }}>
                                                {arrDontMissScripData?.length ? // Prachi T : 21-11-2023 : BT-107423 - Breeze - Dashboard recommemndations
                                                    <CustomVirtualizer data={arrDontMissScripData} itemHeight={100} renderItem={renderItem} />
                                                    :
                                                    <div className='zero-state-alerts zero-state-alerts-md'>
                                                        <ZeroStates subText="Important events related to your portfolio will be displayed here..." icon='icon-64 icon-nodata mb-3 mrgauto' />
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </Col>
                                </Row>

                            </Container >
                            : (
                                location.pathname === LOCATIONS.PORTFOLIO ?
                                    <div className='sticky-dontmiss-height'>
                                        <Container fluid className='p-0'>
                                            <Row className='g-0 align-items-center pb-2'>
                                                <Col md={8} className='d-flex justify-content-start align-items-center'>
                                                    <BzToolTip placement='right' TooltipMsg='Get scrip related Events, Recommendations and Holding info upfront'>
                                                        <div className='icon-16 icon-info icon-dark'></div>
                                                    </BzToolTip>
                                                    {arrSearchDontMissByDropdown?.length > 0 &&
                                                        <div className='d-flex align-items-center ms-2'>
                                                            <div className='font-medium font-size3 color-text me-2'>Filters:</div>
                                                            <div className='horizontal-scroll-wrap filters-chips-wrap flex-nowrap'>
                                                                {arrSearchDontMissByDropdown?.map((event) =>
                                                                    <BzChip className='filter-chip me-1 text-capitalize'>{event}<div className='icon-10 icon-close icon-dark ms-2' onClick={handleFilterEventDelete.bind(this, event)}></div></BzChip>
                                                                )}
                                                            </div>
                                                        </div>
                                                    }
                                                </Col>
                                                <Col md={4} className='d-flex align-items-center justify-content-end'>
                                                    <div className='position-relative w-70'>
                                                        <div className='icon-14 icon-search icon-grey search-icon-position'></div>
                                                        <BzInputText disabled={dontScripsByLocation?.length <= 0} onChange={handleSearchScripBySymbol.bind(this)} size='sm' type='search' placeholder="Search scrips" className='p-l-30 font-regular scripname-searchtext'></BzInputText>
                                                    </div>
                                                    <div className={`icon-16 icon-searchfilter ${dontScripsByLocation?.length > 0 ? 'icon-dark' : 'icon-grey'} ms-3`} onClick={(e) => dontScripsByLocation?.length > 0 ? handleFilterOfDontMiss(e) : null}></div>
                                                </Col>
                                            </Row>

                                            <div className='portfolio-dontmisstabs-scroll h-100'>
                                                <div className='dsidetray-card-wrap h-100' >
                                                    {dontScripsByLocation?.length ?
                                                        arrDontMissScripData?.length > 0 ? <CustomVirtualizer data={arrDontMissScripData} itemHeight={120} renderItem={customListRenderer} />
                                                            :
                                                            <div className='zero-state-alerts zero-state-alerts-xl'>
                                                                <ZeroStates heading="No matches found" subText="Try adjusting your search to find what you are looking for" icon='icon-64 icon-nodata mb-3 mrgauto' />
                                                            </div> :
                                                        <div className='zero-state-alerts zero-state-alerts-xl'>
                                                            <ZeroStates subText="Important events related to your portfolio will be displayed here..." icon='icon-64 icon-nodata mb-3 mrgauto' />
                                                        </div>
                                                    }
                                                </div>
                                            </div>

                                        </Container>
                                    </div>
                                    : null
                            )
                    )
            }
        </>
    );
};

export default memo(DontMiss);